<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-xl-4 col-lg-6">
            <div class="widget-card widget-l-bg-cherry">
                <div class="widget-card-statistic-3 p-4">
                    <div class="widget-card-icon widget-card-icon-large"><icon class="fas" icon="users"></icon></div>
                    <div class="mb-4">
                        <h5 class="widget-card-title mb-0">{{$t('ACTIVEUSERS')}}</h5>
                    </div>
                    <div class="row align-items-center mb-2 d-flex">
                        <div class="col-8">
                            <h2 class="d-flex align-items-center mb-0">
                                {{statistics.childrenCnt}}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-lg-6">
            <div class="widget-card widget-l-bg-blue-dark">
                <div class="widget-card-statistic-3 p-4">
                    <div class="widget-card-icon widget-card-icon-large"><icon class="fas" icon="info"></icon></div>
                    <div class="mb-4">
                        <h5 class="widget-card-title mb-0">{{$t('NUMEROFTHERAPYMONTH')}}</h5>
                    </div>
                    <div class="row align-items-center mb-2 d-flex">
                        <div class="col-8">
                            <h2 class="d-flex align-items-center mb-0">
                                {{statistics.monthArrivalRecord}}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-lg-6">
            <div class="widget-card widget-l-bg-green-dark">
                <div class="widget-card-statistic-3 p-4">
                    <div class="widget-card-icon widget-card-icon-large"><icon class="fas" icon="chart-line"></icon></div>
                    <div class="mb-4">
                        <h5 class="widget-card-title mb-0">{{$t('NUMEROFTHERAPYTOTAL')}}</h5>
                    </div>
                    <div class="row align-items-center mb-2 d-flex">
                        <div class="col-8">
                            <h2 class="d-flex align-items-center mb-0">
                                {{statistics.totalArrivalRecord}}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
      <div class="col-sm-8">
        <div class="card card-green">
          <div class="card-body table-responsive">
            <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                <thead>
                  <tr>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('STARTTIME')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in eventsToday.root">
                    <tr :key="item.eventId" aria-rowindex="1" class=" table-ellipsis">
                      <td v-if="item.childId == null">{{item.subject}}</td>
                      <td v-else>
                        <router-link :to="'/admin/children/child/childdetails/'+ item.childId">
                        {{item.subject}} </router-link> <icon v-if="item.hasBirthDay" icon="birthday-cake"></icon>
                        </td>
                      <td>{{moment.utc(item.startTime).local().format('DD.MM.YYYY HH:mm:ss')}}</td>
                    </tr>
                  </template>
                </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="card card-blue">
          <div class="card-body">

              <div class="row">
                <div class="col-sm-12  table-responsive">
                  <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                    <thead>
                      <tr>
                        <th>{{$t('NOTE')}}</th>
                        <th>{{$t('ISREAD')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="item in notes.root">
                        <tr :key="item.noteId" aria-rowindex="1" class=" table-ellipsis">
                          <td>{{item.note}}</td>
                          <td><button type="button" class="btn btn-primary button-delete" @click="markRead(item.noteId)">{{$t('READNOTE')}}</button></td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12">
                  <button type="button" class="btn btn-primary button-add pull-right" @click="showNoteModal()">{{$t('NEWNOTE')}}</button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card card-yellow">
          <div class="card-body">
            <div class="row">
                <div class="col-sm-12">
                    <form>
                        <div class="form-row pl-0 mb-0">
                            <div class="col-sm-2">
                                <label class="custom-label">{{$t('USERS')}}</label>
                                <select class="form-control" v-model="selectedUser">
                                <option value="">{{$t('ALL')}}</option>
                                <option
                                    v-for="item in users.root"
                                    :key="item.userId"
                                    :value="item.userId">{{item.username}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" class="btn btn-primary button-add pull-left mt-4" @click="duplicateCalendar()">{{$t('DUPLICATETONEXTWEEK')}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="mt-2">
              <ejs-schedule ref='scheduleObj' :popupOpen='onPopupOpen'
                                              :selectedDate='selectedDate'
                                              :views='views'
                                              :eventSettings='eventSettings'
                                              startHour='08:00'
                                              endHour='20:00'
                                              :firstDayOfWeek='firstDayOfWeek'
                                              :navigating='onNavigating'
                                              :eventRendered='onEventRendered'
                                              :currentView='currentView'>
                <e-views>
                    <e-view option='Day'></e-view>
                    <e-view option='WorkWeek' :workDays='workDays'></e-view>
                    <e-view option='Month'></e-view>
                </e-views>
              </ejs-schedule>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('EVENTSFORM')" ok-title="submit" hide-footer no-close-on-backdrop no-close-on-esc @hide="hideModal()">
      <div class="d-block">
        <eventsform v-bind:formData="formData" v-bind:formError="formError" v-bind:users="users"></eventsform>
      </div>
      <div>
        <b-btn class="mt-3 float-left button-dlt btn" v-if="showDelete" @click="deleteRow(formData.eventId)">{{$t('DELETE')}}</b-btn>
        <router-link
          v-if="formData.childId"
          :to="{ name: 'CHILDDETAILS', params: { childId: formData.childId } }"
          class="mt-3 float-left ml-2 btn btn-link"
        >
          {{ $t('GO_TO_CHILD_DETAILS') }}
        </router-link>
        <b-btn class="mt-3 float-right ml-1 button-save btn" variant="success" v-if="showDelete" @click="duplicateData(formData)">{{$t('DUPLICATE')}}</b-btn>
        <b-btn class="mt-3 float-right ml-1 button-save btn" variant="primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
        <b-btn class="mt-3 float-right btn button-cancel" variant="secondary mr-lg" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
      </div>
    </b-modal>
    <b-modal ref="formnotemodal" :title="$t('NOTEFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <noteform v-bind:formData="noteFormData" v-bind:formError="formError"></noteform>
      </div>
      <div class="text-right">
        <b-btn class="mt-3" variant="btn button-cancel mr-lg" @click="hideNoteModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="mt-3 btn button-save" @click="submitNoteData(noteFormData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';

import moment from 'moment';
import EventsApi from '@/api/child/Events';
import NotesApi from '@/api/notes/Note';
import UsersApi from '@/api/admin/Users';

import {
    Day, Week, WorkWeek, Month, Agenda,
} from '@syncfusion/ej2-vue-schedule';
import {
    extend, L10n, loadCldr, setCulture,
} from '@syncfusion/ej2-base';
import localText from '@/components/translation/locale.json';
import numberingSystems from '@/components/translation/numberingSystems.json';
import gregorian from '@/components/translation/ca-gregorian.json';
import numbers from '@/components/translation/numbers.json';
import timeZoneNames from '@/components/translation/timeZoneNames.json';
import NoteForm from './NoteForm.vue';
import EventsForm from './EventsForm.vue';

L10n.load(localText);
loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);
setCulture('hr-BA');
export default
{
    name: 'dashboard',
    components:
  {
      eventsform: EventsForm,
      noteform: NoteForm,
  },
    provide: {
        schedule: [Day, Week, WorkWeek, Month, Agenda],
    },
    data()
    {
        return {
            selectedDate: moment().toDate(),
            firstDayOfWeek: 1,
            users: {},
            statistics: {},
            scheduleDate: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            views: ['Day', 'WorkWeek', 'Month'],
            currentView: 'WorkWeek',
            workDays: [1, 2, 3, 4, 5, 6],
            eventSettings: {},
            selectedUser: '',
            formError:
      {},
            notes: {},
            showDelete: false,
            formData:
      {
          subject: '',
          startTime: '',
          endTime: '',
          childId: null,
          roomId: 0,
          userId: null,
      },
            eventsToday: {},
            noteFormData: {
                note: '',
            },
        };
    },
    async created()
    {
        const me = this;

        try
        {
            await me.getData();
            await me.getToday();
            await me.getNotes();
            await me.getStatistics();
            me.getUsers();
        }
        catch (error)
        {
            me.$notify.notice(error);
        }
    },
    methods:
  {
      async getUsers()
      {
          const me = this;
          try
          {
              const data = await UsersApi.selectRow();
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              for (let i = 0; i < data.root.length; i += 1)
              {
                  data.root[i].password = '';
                  data.root[i].trhidden = false;
              }

              me.users = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      onEventRendered(args)
      {
          const categoryColor = args.data.CategoryColor;
          if (!args.element || !categoryColor)
          {
              // console.log('mirko');
          }
          else
          {
              args.element.style.backgroundColor = categoryColor;
          }
      },
      onPopupOpen(args)
      {
      // console.log(args);
          const me = this;
          if (args.type === 'Editor')
          {
              args.cancel = true;
          }
          else if (args.type === 'QuickInfo')
          {
              args.cancel = true;
              me.formError = {};
              if (args.data.Id !== undefined)
              {
                  me.showDelete = true;
                  me.formData.subject = args.data.subjectFormData;
                  me.formData.eventId = args.data.Id;
                  me.formData.roomId = args.data.roomId;
                  me.formData.childId = args.data.childId;
                  me.formData.userId = args.data.userId;
                  me.formData.startTime = moment(args.data.StartTime).format('YYYY-MM-DD HH:mm:ss');
                  me.formData.endTime = moment(args.data.EndTime).format('YYYY-MM-DD HH:mm:ss');
              }
              else
              {
                  me.showDelete = false;
                  me.formData.userId = me.globals.userId;
                  me.formData.startTime = moment(args.data.StartTime).format('YYYY-MM-DD HH:mm:ss');
                  me.formData.endTime = moment(args.data.StartTime).add(45, 'minutes').format('YYYY-MM-DD HH:mm:ss');
                  // me.formData.endTime = moment(args.data.EndTime).format('YYYY-MM-DD HH:mm:ss');
              }

              this.$refs.formmodal.show();
          }
      },
      async duplicateCalendar()
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const params = { date: me.scheduleDate, userId: me.selectedUser };
                          const data = await EventsApi.duplicateCalendar(params);
                          if (data.error && data.error === true)
                          {
                              throw (data);
                          }

                          me.$notify.notice(data);
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getToday()
      {
          const me = this;
          try
          {
              const data = await EventsApi.selectToday();
              if (data.error && data.error === true)
              {
                  throw (data);
              }

              me.eventsToday = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getNotes()
      {
          const me = this;
          try
          {
              const data = await NotesApi.selectNote();
              if (data.error && data.error === true)
              {
                  throw (data);
              }

              me.notes = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getStatistics()
      {
          const me = this;
          try
          {
              const data = await EventsApi.getStatistics();
              if (data.error && data.error === true)
              {
                  throw (data);
              }

              me.statistics = data.root;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getData()
      {
          const me = this;
          try
          {
              const data = await EventsApi.selectRow({ date: me.scheduleDate, userId: me.selectedUser });
              if (data.error && data.error === true)
              {
                  throw (data);
              }

              me.eventSettings = { dataSource: extend([], data.root, null, true) };
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async onNavigating(args)
      {
          const me = this;
          try
          {
              if (args.currentDate !== undefined)
              {
                  me.scheduleDate = moment(args.currentDate).utc().format('YYYY-MM-DD HH:mm:ss');
                  await me.getData();
              }
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async duplicateData(item)
      {
          const me = this;
          const val = { ...item };
          delete (val.eventId);
          await me.submitData(val);
      },
      async submitData(i)
      {
          const me = this;
          try
          {
              const item = { ...i };
              if (typeof item.eventId !== 'undefined')
              {
                  item.id = item.eventId;
                  delete (item.eventId);
              }

              if (item.roomId != null && parseInt(item.roomId, 10) === 0)
              {
                  item.roomId = null;
              }

              item.startTime = moment(item.startTime).utc().format('YYYY-MM-DD HH:mm:ss');
              item.endTime = moment(item.endTime).utc().format('YYYY-MM-DD HH:mm:ss');

              const data = await EventsApi.submitData(item);
              if (data.error)
              {
                  me.formError = data;
                  throw (data);
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  // me.scheduleDate = item.startTime;
                  await me.getData();
                  await me.getToday();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              subject: '',
              startTime: '',
              endTime: '',
              roomId: 0,
              childId: null,
          };
          me.formError = {};
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await EventsApi.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          me.hideModal();
                          await me.getData();
                          await me.getToday();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showNoteModal()
      {
          const me = this;
          me.$refs.formnotemodal.show();
      },
      async submitNoteData(item)
      {
          const me = this;
          try
          {
              const data = await NotesApi.submitData(item);
              if (data.error)
              {
                  me.formError = data;
                  throw (data);
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideNoteModal();
                  await me.getNotes();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideNoteModal()
      {
          const me = this;
          this.$refs.formnotemodal.hide();

          me.noteFormData = {
              note: '',
          };
      },
      async markRead(id)
      {
          const me = this;
          try
          {
              const data = await NotesApi.readNote({ noteId: id });
              if (data.error)
              {
                  throw (data);
              }
              else
              {
                  me.$notify.notice(data);
                  await me.getNotes();
              }
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      getHasBirthday(item)
      {
         const birthDayCake = '<icon icon="birthday-cake"></icon>';

         return birthDayCake;
      },
  },
    watch:
  {
      async selectedUser()
      {
          const me = this;
          try
          {
              await me.getData();
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
  },
};
</script>


<style>
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';

  .e-today {
        display: none !important;
    }
</style>
